/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import * as Sentry from '@sentry/react';
import User from "../models/userModel";
import Account from "../models/accountModel";

export const setSentryUser = (user: User, account?: Account | null) => {
    const email: string = account?.email || user.email, id: string = account?.id || user.id,
        entity: string = account ? 'account' : 'user';
    Sentry.setUser({email, id, entity});
};

export const reportError = (error: Error) => {
    Sentry.captureException(error);
}